import React from 'react';
import { connect } from 'react-redux';
import MetaFieldsContainer from './MetaFieldsContainer';

import {
    clearAllFields
} from '../../actions/AppActions';
import { BlobProvider } from '@react-pdf/renderer';

import './style.css';
import DownloadFilesButton from '../DownloadFilesButton/DownloadFilesButton';

const Jumbotron = ({ previewButtonText, invoicePreviewClickHandler,
    clearFieldsButtonPressed, doc, fileName }) => {

    return (
        <div className="jumbotron">

            <label id="toggle-meta-fields-label" htmlFor="toggle-meta-fields-btn">Toggle Meta Fields</label>
            <input type="checkbox" id="toggle-meta-fields-btn"></input>

            <MetaFieldsContainer />

            <div id="title-area">
                <h1>Interest Calculator</h1>
                <h3>Associated Medical Centers of Illinois</h3>
            </div>

            <div className="buttons-container">
                <button
                    onClick={() => {clearFieldsButtonPressed(); document.getElementById('testform').reset()}}
                    id="clear-fields-btn"
                >Clear Fields</button>

                <BlobProvider document={doc} fileName={fileName}>
                    {({ blob, url, loading, error }) => {
                        return (
                            loading ? 'Loading doc...'
                                : <DownloadFilesButton invoiceFileName={fileName} pdfBlob={blob} />)
                    }}
                </BlobProvider>


                <button
                    id={"preview-invoice-button"}
                    onClick={() => invoicePreviewClickHandler()}
                >{previewButtonText}</button>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    clearFieldsButtonPressed: () => dispatch(clearAllFields())
})

export default connect(
    null,
    mapDispatchToProps
)(Jumbotron);